import { FormRendererAPIType } from 'components/common/form/index';
import { useEffect, useRef, useState } from 'react';

export default function useWatchFormGridsChanges(form: FormRendererAPIType, grids: Array<string>) {
    const [changedGrids, setChangedGrids] = useState<Array<string>>([]);
    const getCurrentGridsValues = () => {
        return grids.reduce((f: any, key) => {
            f[key] = undefined;
            return f;
        }, {});
    };
    const resetChangedGrids = () => {
        setChangedGrids([]);
        defaultState.current = getCurrentGridsValues();
    };
    const defaultState = useRef(getCurrentGridsValues());
    const vList = form.hookFormWatch(grids);
    useEffect(() => {
        if (!Array.isArray(vList)) {
            return;
        }
        for (let i = 0; i < vList.length; i++) {
            if (defaultState.current[grids[i]] == undefined && vList[i] != undefined) {
                defaultState.current[grids[i]] = JSON.stringify(vList[i]);
            }
        }
    }, [JSON.stringify(vList)]);

    useEffect(() => {
        if (!Array.isArray(vList)) {
            return;
        }
        const changed = [];
        for (let i = 0; i < vList.length; i++) {
            if (defaultState.current[grids[i]] != JSON.stringify(vList[i])) {
                changed.push(grids[i]);
            }
        }
        setChangedGrids(changed);
    }, [JSON.stringify(vList)]);

    return { changedGrids, resetChangedGrids };
}
